<template>
  <OurConfirmModal
    v-model="isShownModal"
    :title="title || $t('title.users.delete')"
    :action-button-text="$t('button.remove')"
    color="gray"
    @actionConfirmed="onClickDeleteButton"
  >
    <OurTextBlock v-html="deleteConfirm || $t('page.users.removeConfirm', { name })" />
  </OurConfirmModal>
</template>

<script>
import apolloMixin from "@/mixins/apollo.mixin";

export default {
  name: "DeleteModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    userId: {
      type: String,
      default: "",
    },

    name: {
      type: String,
      default: "",
    },
    mutation: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: "",
    },
    deleteConfirm: {
      type: String,
      default: "",
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },

  methods: {
    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickDeleteButton() {
      await this.$post(this.mutation, { userId: this.userId }, { delaySuccessNotify: true });

      this.$emit("deleteUser");
    },
  },
};
</script>
